/**
 * In-memory cache for Content Bank table results.
 * Survives route unmount/remount within the same SPA session so Back
 * from content-creation can restore the table without a loading flash.
 */

const store = new Map();

export function makeContentBankCacheKey(table, filters = {}, pagination = {}) {
  return JSON.stringify({
    table,
    subject_id: filters.subject_id || null,
    topic_id: filters.topic_id || null,
    sub_topic_id: filters.sub_topic_id || null,
    level: filters.level || null,
    page: pagination.page || 1,
    limit: pagination.limit || 10,
    questionType: filters.questionType || null,
  });
}

export function getContentBankCache(key) {
  if (!key) return null;
  return store.get(key) || null;
}

export function setContentBankCache(key, value) {
  if (!key) return;
  store.set(key, {
    ...value,
    cachedAt: Date.now(),
  });
}

export function invalidateContentBankCache(table) {
  if (!table) {
    store.clear();
    return;
  }
  for (const key of Array.from(store.keys())) {
    try {
      const parsed = JSON.parse(key);
      if (parsed.table === table) store.delete(key);
    } catch {
      store.delete(key);
    }
  }
}
